import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {objectHelpers} from '../../utils/helpers';
import StatusLine from '../StatusLine';
import StyledStatusMark from './StyledStatusMark';

const StatusMark = ({
  statusCode,
  statuses,
  ...rest
}) => {
  const [t] = useTranslation('main');

  const status = objectHelpers.getStatus(statusCode, statuses);

  return (
    <StyledStatusMark {...rest}>
      <StatusLine color={status.color} /> {t(status.key)}
    </StyledStatusMark>
  );
}

StatusMark.propTypes = {
  statuses: PropTypes.object,
  statusCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
}

export default StatusMark;
